(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js');

'use strict';

const {
  productMapping,
  campaign
} = svs.numbergames;
const {
  account_services: accountServices,
  api_calls: apiCalls,
  communication,
  dialogs,
  misc
} = svs.tur.pay;
const {
  ifIsProlongation,
  fetchWager,
  wantToSubscribeDialog,
  setActiveAccount,
  verifyActiveAccount,
  updateAccountBalance,
  checkSyndicateTerms,
  updateDraws,
  ifHasClosedJokerDraws,
  closedJokerDrawDialog,
  removeClosedJoker,
  ifDrawOpenIsToday,
  playNextDrawDialog,
  addDataToWagers,
  confirmPaymentTitle,
  confirmPaymentMessages,
  handlePayResponse,
  ifDrawHasClosed,
  ifHasIncompleteWagers,
  trackPayment
} = svs.numbergames.pay_numbergames;
async function numberOfChances(_ref) {
  let {
    next,
    product,
    successfulWagers
  } = _ref;
  let chances = 0;
  if (productMapping.isLotto(product)) {
    chances = successfulWagers.reduce((acc, _ref2) => {
      let {
        wager: {
          bets
        }
      } = _ref2;
      if (!bets.some(b => b.jokerBoards)) {
        return acc;
      }
      const bet = bets.find(b => b.lottoBoards);
      const hasLotto2 = Boolean(parseInt(bet.betAmountSalesGroup2, 10));
      const numOfBoards = bet => bet.lottoBoards.reduce((acc, board) => acc + svs.numbergames.rules.system.generatedRows({
        numbersLength: board.boardData.length,
        numbersRowSize: svs.numbergames.rules.getRules('lotto').numbersMaxLength
      }), 0);
      return acc + numOfBoards(bet) * bet.numDraws * (hasLotto2 ? 2 : 1);
    }, 0);
  }
  if (productMapping.isKeno(product)) {
    chances = await campaign.calculateChances({
      product,
      wagers: successfulWagers.map(_ref3 => {
        let {
          wager
        } = _ref3;
        return wager;
      }),
      useTotalChances: true
    });
  }
  return next({
    chances
  });
}
function calculateActualPaidPrice(_ref4) {
  let {
    next,
    successfulWagers,
    successfulTickets
  } = _ref4;
  const wagersPrice = (sum, _ref5) => {
    let {
      wagerAmounts
    } = _ref5;
    return sum + svs.utils.format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  };
  const ticketsPrice = (sum, _ref6) => {
    let {
      price
    } = _ref6;
    return sum + price;
  };
  next({
    actualPaidPrice: successfulWagers.reduce(wagersPrice, 0) + successfulTickets.reduce(ticketsPrice, 0)
  });
}
function setWageridQuery(_ref7) {
  let {
    next,
    wagerId
  } = _ref7;
  svs.utils.paramHandler.set({
    key: 'wagerid',
    value: wagerId
  });
  next();
}
function removeWageridQuery(_ref8) {
  let {
    next
  } = _ref8;
  svs.utils.paramHandler.remove({
    key: 'wagerid'
  });
  next();
}
function saveProlongedWagerIdToLocalStorage(_ref9) {
  let {
    wagerId,
    next
  } = _ref9;
  svs.components.Storage.browser.set(wagerId, 'numbergameProlong', true, svs.components.Storage.constants.EXPIRES_1H);
  next();
}
function makePayment(_ref0) {
  let {
    onDoneCb,
    onSuccessCb,
    onCancelCallback,
    saveState,
    wagerData,
    ticketData,
    wagerId
  } = _ref0;
  let product;
  let price;
  let drawCount;
  let wagers;
  let syndicateId;
  let isSyndicate;
  let syndicate;
  let accountBalance;
  let draws;
  let regWagerResults;
  let closedWager;
  let incompleteWagers;
  let successfulWagers;
  let failedWagers;
  let grassrootsReceivers;
  let chances;
  let successfulTickets;
  let failedTickets;
  let actualPaidPrice;
  if (wagerData) {
    ({
      product,
      price,
      drawCount,
      wagers
    } = wagerData);
    if (ticketData) {
      price += ticketData.price;
    }
  }
  if (wagerId) {
    const originalOnCancelCallback = onCancelCallback;
    onCancelCallback = () => {
      svs.numbergames.accountSelector.usePlayerAccount();
      originalOnCancelCallback === null || originalOnCancelCallback === void 0 || originalOnCancelCallback();
    };
    const originalOnDoneCb = onDoneCb;
    onDoneCb = () => {
      svs.numbergames.accountSelector.usePlayerAccount();
      originalOnDoneCb === null || originalOnDoneCb === void 0 || originalOnDoneCb();
    };
  }
  const calls = [{
    in: () => ({
      price,
      product,
      drawCount
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, ifIsProlongation({
    params: () => ({
      wagerId
    }),
    calls: () => [{
      in: () => ({
        wagerId
      }),
      fn: setWageridQuery
    }, {
      in: () => ({
        wagerId
      }),
      fn: fetchWager,
      out: args => ({
        product,
        price,
        wagers,
        syndicateId
      } = args)
    }, {
      in: () => ({
        wagers,
        syndicateId,
        product,
        wagerId
      }),
      fn: wantToSubscribeDialog
    }, {
      in: () => ({
        syndicateId
      }),
      fn: setActiveAccount
    }]
  }), {
    fn: verifyActiveAccount,
    out: args => ({
      isSyndicate,
      syndicate
    } = args)
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: checkSyndicateTerms
  }, {
    in: () => ({
      price,
      isSyndicate,
      syndicate
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, function mainPaymentSequence(isRetry) {
    return {
      calls: [{
        in: () => ({
          wagers
        }),
        fn: updateDraws,
        out: args => ({
          draws
        } = args)
      }, ifHasClosedJokerDraws({
        params: () => ({
          wagers,
          draws
        }),
        calls: _ref1 => {
          let {
            productWithClosedJoker
          } = _ref1;
          return [{
            in: () => ({
              productWithClosedJoker
            }),
            fn: closedJokerDrawDialog
          }, {
            in: () => ({
              wagers,
              price,
              productWithClosedJoker
            }),
            fn: removeClosedJoker,
            out: args => ({
              wagers,
              price
            } = args)
          }];
        }
      }), ifDrawOpenIsToday({
        params: () => ({
          wagers,
          draws
        }),
        calls: _ref10 => {
          let {
            productOpenedToday,
            regCloseTime
          } = _ref10;
          return [{
            in: () => ({
              product: productOpenedToday,
              regCloseTime,
              isSyndicate
            }),
            fn: playNextDrawDialog
          }];
        }
      }), {
        in: () => ({
          wagers,
          draws,
          isSyndicate,
          syndicate
        }),
        fn: addDataToWagers,
        out: args => ({
          wagers
        } = args)
      }, ...(isRetry ? [] : [{
        in: () => ({
          accountBalance,
          isSyndicate,
          syndicate,
          price,
          title: confirmPaymentTitle({
            product,
            wagers,
            price,
            isSyndicate,
            ticket: ticketData
          }),
          messages: confirmPaymentMessages(wagers, product),
          product,
          isProlongation: new RegExp(/\/[a-z]+\/forlang-mina-spel\/[0-9]+/).test(window.location.pathname)
        }),
        fn: dialogs.confirmPayment
      }]),
      {
        in: () => ({
          wagers,
          product
        }),
        fn: svs.numbergames.rules.utils.lotto.toApiWagersLottoNewRules,
        out: args => ({
          wagers
        } = args)
      }, {
        in: () => ({
          wagers
        }),
        fn: apiCalls.payWagers,
        out: args => ({
          regWagerResults
        } = args)
      }, {
        in: () => ({
          regWagerResults,
          wagers,
          successfulWagers,
          failedWagers
        }),
        fn: handlePayResponse,
        out: args => ({
          closedWager,
          incompleteWagers,
          successfulWagers,
          failedWagers
        } = args)
      }, ifDrawHasClosed({
        params: () => ({
          closedWager
        }),
        calls: () => [mainPaymentSequence.bind(null, true)]
      })]
    };
  }, function handleIncompleteWagers() {
    return {
      calls: [ifHasIncompleteWagers({
        params: () => ({
          incompleteWagers
        }),
        calls: () => [{
          in: () => ({
            wagers: incompleteWagers
          }),
          fn: apiCalls.payWagers,
          out: args => ({
            regWagerResults
          } = args)
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => ({
            incompleteWagers,
            successfulWagers,
            failedWagers
          } = args)
        }, handleIncompleteWagers]
      })]
    };
  }, {
    in: () => ({
      ticket: ticketData,
      channel: product
    }),
    fn: apiCalls.payTicket,
    out: args => ({
      successfulTickets,
      failedTickets
    } = args)
  }, {
    in: () => ({
      successfulWagers,
      successfulTickets
    }),
    fn: calculateActualPaidPrice,
    out: args => ({
      actualPaidPrice
    } = args)
  }, {
    in: () => ({
      accountBalance,
      actualPaidPrice,
      syndicate,
      isSyndicate
    }),
    fn: updateAccountBalance
  }, {
    fn: _ref11 => {
      let {
        next
      } = _ref11;
      onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb({
        successfulWagers
      });
      next();
    }
  }, ifIsProlongation({
    params: () => {
      var _wagerData$prolongedW;
      return {
        wagerId: (_wagerData$prolongedW = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW !== void 0 ? _wagerData$prolongedW : wagerId
      };
    },
    calls: () => [{
      in: () => {
        var _wagerData$prolongedW2;
        return {
          wagerId: (_wagerData$prolongedW2 = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW2 !== void 0 ? _wagerData$prolongedW2 : wagerId
        };
      },
      fn: saveProlongedWagerIdToLocalStorage
    }, {
      fn: removeWageridQuery
    }]
  }), {
    in: () => ({
      product,
      successfulWagers,
      syndicate,
      isSyndicate
    }),
    fn: trackPayment
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: misc.getGrassrootsReceivers,
    out: args => ({
      grassrootsReceivers
    } = args)
  }, {
    in: () => ({
      product,
      successfulWagers
    }),
    fn: numberOfChances,
    out: args => ({
      chances
    } = args)
  }, {
    in: () => ({
      product,
      isSyndicate,
      successfulTickets,
      title: dialogs.getSuccessTitle({
        product,
        isSyndicate,
        failedWagers,
        successfulWagers,
        failedTickets
      }),
      messages: dialogs.getSuccessMessages({
        product,
        price: actualPaidPrice,
        isSyndicate,
        syndicate,
        grassrootsReceivers,
        chances,
        failedWagers,
        successfulTickets,
        failedTickets
      })
    }),
    fn: dialogs.paymentSuccess
  }, {
    in: () => ({
      product: productMapping.getProductName(product)
    }),
    fn: communication.correctionEmail
  }, ifIsProlongation({
    params: () => ({
      wagerId
    }),
    calls: () => [{
      fn: svs.tur.pay.misc.showGrassrootsToaster
    }]
  })];
  svs.tur.pay.initPay({
    calls,
    cancel: () => {
      var _onCancelCallback;
      (_onCancelCallback = onCancelCallback) === null || _onCancelCallback === void 0 || _onCancelCallback();
    },
    done: () => {
      var _onDoneCb;
      (_onDoneCb = onDoneCb) === null || _onDoneCb === void 0 || _onDoneCb({
        price: actualPaidPrice
      });
    },
    saveState
  });
}
svs.numbergames.pay_numbergames.makePayment = makePayment;

 })(window);